'use strict';

/* global L */

var centroid = require('turf-centroid');
function MapController ($interval, $scope, $timeout, MapRegistry, ManagerStore) {

  var vm = this;
  vm.MapRegistry = MapRegistry;
  vm.visible = false;
  vm.popupContent = '';
  vm.showPopup = false;
  vm.loading = false;
  vm.activeLayers = []; // FIXME
  vm.editableTypes = ['photos', 'gcps', 'bases'];
  vm.location = {
    autoDiscover: false,
    lat: 37.7749, // default SF
    lng: -122.4194 // default SF
  };


  vm.mission = {
    id: 1,
    photos: [],
    zones: [{
      id: 1,
      type: 'zone',
      base: {
        id: 1,
        type: 'base',
        data: {},
      },
      data: {}
    }]
  };


  vm.closePopup = function () {
    vm.showPopup = false;
  };

  vm.openedPopup = function () {
    vm.showPopup = true;
    vm.loading = false;
  };

  vm._onUpdateActiveLayer = function (event, activeLayer) {
    vm.activeLayer = activeLayer;
  };

  vm.deleteLayer = function () {
    //FilesService.deletePhotoByHash('photos', file.$$hashKey);
  };

  vm.updateMap = function() {
    vm.loading = true;
    let center = centroid(ManagerStore.get('job').dataset.meta.polygon);
    vm.location.lat = center.geometry.coordinates[1];
    vm.location.lng = center.geometry.coordinates[0];

    let zone = vm.mission.zones[0];

    zone.base.data = center;
    zone.data = ManagerStore.get('job').dataset.meta.polygon;
    zone.data.properties = zone.data.properties || {};
    zone.data.properties.style = {};
    zone.data.properties.style.color = 'black';
    vm.mission = {
      id: 1,
      photos: ManagerStore.get('job').dataset.meta.points,
      zones: vm.mission.zones
    };
    if (ManagerStore.get('job').dataset.meta.gcps) {
      Object.assign(vm.mission, {
        gcps: ManagerStore.get('job').dataset.meta.gcps
      });
    }
    if (ManagerStore.get('job').dataset.meta.antenna) {
      vm.mission.zones[0].base = ManagerStore.get('job').dataset.meta.antenna;
    }
    $timeout(function(){
      MapRegistry.getWrapper('plot').getMap().then(function(map) {
        var geojsonLayer = L.geoJson(ManagerStore.get('job').dataset.meta.polygon);
        map.fitBounds(geojsonLayer.getBounds());
        map.panTo(vm.location);
        map.scrollWheelZoom.disable();
        vm.loading = false;
      });
      vm.loading = false;
    }, 500);
  };

  vm.redrawMap = function () {
    vm.loading = true;
    $timeout(function(){
      MapRegistry.getWrapper('plot').getMap().then(function(map) {
        var geojsonLayer = L.geoJson(ManagerStore.get('job').dataset.meta.polygon);
        var center = centroid(ManagerStore.get('job').dataset.meta.polygon);
        vm.location.lat = center.geometry.coordinates[1];
        vm.location.lng = center.geometry.coordinates[0];
        map.fitBounds(geojsonLayer.getBounds());
        map.scrollWheelZoom.disable();
        vm.loading = false;
      });
      vm.loading = false;
    }, 500);
  };

  vm.hideMap = function() {
    vm.visible = false;
  };

  this.updateMap();

  $scope.$on('map:activeLayerChange', this._onUpdateActiveLayer.bind(this));
}

MapController.$inject = ['$interval', '$scope', '$timeout', 'sbMapRegistry', 'ManagerStore', 'leafletData'];
module.exports = MapController;



// WEBPACK FOOTER //
// ./src/app/manager/processing/map/MapController.js